import { format } from 'date-fns';
import { tz } from '@date-fns/tz';

/**
 * UTC日時文字列をJST（+09:00）形式のタイムスタンプに変換する
 * 実行環境のタイムゾーンに依存せず、常にJSTで出力する
 * @param utcDateString UTC形式の日時文字列（例: "2024-01-01T04:34:56" or "2024-01-01T04:34:56.000Z"）
 * @returns JSTタイムスタンプ（例: "2024-01-01T13:34:56+09:00"）
 */
export function formatUtcToJstTimestamp(utcDateString: string) {
  // タイムゾーン情報がない場合はUTCとして扱うためにZを付加
  const normalizedDateStr = utcDateString.endsWith('Z')
    ? utcDateString
    : `${utcDateString}Z`;
  const date = new Date(normalizedDateStr);
  return format(date, "yyyy-MM-dd'T'HH:mm:ssXXX", { in: tz('Asia/Tokyo') });
}

export function formatTimestamp(date: Date) {
  return format(date, "yyyy-MM-dd'T'HH:mm:ss");
}

export function formatTimestampTZ(date: Date) {
  return format(date, "yyyy-MM-dd'T'HH:mm:ss+09:00");
}

export function formatDateTime(date: Date) {
  return format(date, 'yyyy-MM-dd HH:mm:ss');
}

export function formatDate(date: Date) {
  return format(date, 'yyyy-MM-dd');
}

export function formatDateJa(date: Date) {
  return format(date, 'M月d日');
}

export function formatRFC822(date: Date) {
  return format(date, "eee, dd MMM yyyy HH:mm:ss '+0900'");
}

/**
 * 実行環境のタイムゾーンに依存せず、常に JST（+09:00）基準で現在の年月を返す
 * @returns yyyyMM 形式の文字列（例: "202601"）
 */
export function getCurrentJstDatemonth(): string {
  const jstOffsetMs = 9 * 60 * 60 * 1000;
  const now = new Date(Date.now() + jstOffsetMs);
  const year = now.getUTCFullYear();
  const month = now.getUTCMonth() + 1;
  return `${year}${String(month).padStart(2, '0')}`;
}
